<template>
  <div
    :class="[
      $style.container,
      { [$style.active]: active },
    ]"
  >
    <div :class="[$style[type], $style.filled]">
      <base-icon :name="`basic_${type}-filled`" />
    </div>
    <div :class="[$style[type], $style.filled]">
      <base-icon :name="`basic_${type}-filled`" />
    </div>
    <div :class="$style[type]">
      <base-icon :name="`basic_${type}`" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatingPreview',
  props: {
    type: {
      type: String,
      default: 'star',
    },
    active: Boolean,
  },
};
</script>

<style lang="sass" module>
  .container
    +inline-flex
    padding: 10px
    background-color: var(--color-white)
    border-radius: 40px

    &.active
      background-color: var(--color-violet)

      .star
        color: var(--color-white)

        &.filled
          color: var(--color-yellow)

      .heart
        color: var(--color-white)

        &.filled
          color: var(--color-red)

  .star
    +flexbox
    color: var(--color-yellow)
    color: var(--color-black)

    &.filled
      color: var(--color-yellow)

  .heart
    +flexbox
    color: var(--color-red)
    color: var(--color-black)

    &.filled
      color: var(--color-red)
</style>
